var map = {
	"./3CX_advanced.png": "1b20",
	"./3CX_basic.png": "bd9a",
	"./3CX_intermediate.png": "3e34",
	"./MTCNA.png": "d254",
	"./Microsoft_AZ-220.png": "9387",
	"./Microsoft_AZ-900.png": "61e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "323d";